/** Memory do Brain (AB#87149): o que pessoas e agentes pediram para lembrar. */

export type MemoryScope = "organization" | "workspace" | "user";
export type MemoryKind = "fact" | "decision" | "preference" | "event";
/** `review`: proposta aceita em Learnings (AB#87286). */
export type MemorySource = "ui" | "conversation" | "workflow" | "review";
export type MemoryStatus = "pending" | "active" | "failed" | "expired";

export const MEMORY_KINDS: MemoryKind[] = ["fact", "decision", "preference", "event"];
export const MEMORY_STATUSES: MemoryStatus[] = ["active", "pending", "failed", "expired"];

/** Teto do conteúdo de uma memória — o mesmo da api. */
export const MEMORY_CONTENT_MAX = 2000;

export interface MemoryAuthor {
  id: string;
  full_name: string | null;
  email: string | null;
}

export interface Memory {
  id: string;
  scope: MemoryScope;
  product_id: string | null;
  user_id: string | null;
  kind: MemoryKind;
  content: string;
  source: MemorySource;
  source_ref: { agent_id?: string | null; client?: string | null; connection?: string | null };
  status: MemoryStatus;
  index_error: string | null;
  expires_at: string | null;
  created_at: string | null;
  updated_at: string | null;
  author: MemoryAuthor | null;
  can_edit: boolean;
}

export interface MemoryFact {
  id: string;
  fact: string;
  valid_at: string | null;
  invalid_at: string | null;
  current: boolean;
}

/** Em que nível a tela está: o escopo e, no workspace, qual. */
export interface MemoryTarget {
  scope: MemoryScope;
  productId?: string | null;
}

/** Validade escolhida no formulário. */
export type MemoryValidity = "permanent" | "1d" | "7d" | "30d" | "custom";

export interface MemoryInput {
  /** Só na edição: leva a memória para outro escopo. */
  scope?: MemoryScope;
  kind: MemoryKind;
  content: string;
  validity: MemoryValidity;
  /** `YYYY-MM-DD`, quando `validity` é `custom`. */
  customDate?: string;
  /**
   * Só na edição: `false` quando a pessoa não mexeu na validade. A api então a mantém —
   * reenviá-la recalculada mudaria a data e sobrescreveria uma renovação feita no meio-tempo.
   */
  validityChanged?: boolean;
}
